import { NamedError } from '../../utils/Errors';

export enum OneDriveUploadTaskErrors {
    OneDriveQuotaLimitReached = 'OneDriveQuotaLimitReached',
    ForbiddenOneDriveAccess = 'ForbiddenOneDriveAccess'
}

export class OneDriveUploadTaskError extends NamedError<OneDriveUploadTaskErrors> {}